import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import ContentLoader from 'react-content-loader';
import { injectIntl } from 'react-intl';
import { withTheme } from '@material-ui/core/styles';

import icon5 from 'assets/images/5.png';
import icon6 from 'assets/images/6.png';
import icon7 from 'assets/images/7.png';
import business from 'assets/images/business-img.jpg';

class BusinessDirector extends React.Component {
    state = { expanded: false, clickValue: false, itemId: '', markedFav: 0 };

    render() {
        return (
            <div>
                <div className="com-padd quic-book-ser-full">
                    <div className="quic-book-ser">
                        <div className="quic-book-ser-inn">
                            <div className="quic-book-ser-left">
                                <img
                                    src={business}
                                    alt="business"
                                    className="business"
                                />
                            </div>
                            <div className="quic-book-ser-right">
                                <div className="hom-cre-acc-left">
                                    <h3>
                                        What service do you need?
                                        <span> Business Directory</span>
                                    </h3>
                                    <p>
                                        Tell us more about your requirements so
                                        that we can connect you to the right
                                        service provider.
                                    </p>
                                    <ul>
                                        <li>
                                            <img
                                                src={icon7}
                                                alt="icon"
                                                className="icon7"
                                            />
                                            <div>
                                                <h5>
                                                    Tell us more about your
                                                    requirements
                                                </h5>
                                                <p>
                                                    Imagine you have made your
                                                    presence online through a
                                                    local online directory, but
                                                    your competitors have..
                                                </p>
                                            </div>
                                        </li>
                                        <li>
                                            <img
                                                src={icon6}
                                                alt="icon"
                                                className="icon6"
                                            />
                                            <div>
                                                <h5>
                                                    We connect with right
                                                    service provider
                                                </h5>
                                                <p>
                                                    Advertising your business to
                                                    area specific has many
                                                    advantages. For local
                                                    businessmen, it is an
                                                    opportunity..
                                                </p>
                                            </div>
                                        </li>
                                        <li>
                                            <img
                                                src={icon5}
                                                alt="icon"
                                                className="icon5"
                                            />
                                            <div>
                                                <h5>Happy with our service</h5>
                                                <p>
                                                    Your local business too
                                                    needs brand management and
                                                    image making. As you know
                                                    the local market..
                                                </p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const composedComponent = compose(
    withTheme()
    // withStyles(carouselStyle, styles),
);
export default composedComponent(injectIntl(BusinessDirector));



// WEBPACK FOOTER //
// ./src/components/Providers/BusinessDirector.js